import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { RegistrationFormContentType } from '../contentTypes';
import { Page } from './Page';

export interface RegistrationPageProps {}

export const RegistrationPage = (props: RegistrationPageProps) => {
  const content = b2x.useContent<RegistrationFormContentType>('REGISTRATION_FORM_CONTENT');

  return (
    <Page className="registration-page my-5" noPaddingTop thingsToLoadBeforePageReady={[content]}>
      <Container>
        <b2x.Row className="justify-content-center">
          <b2x.Col size={{ lg: 9, xl: 7 }}>
            <div className="mb-5 text-center">
              <h3 className="text-uppercase fw-medium mb-3">{b2x.formatHtml(content?.body.title)}</h3>
              <p className="fw-normal">{b2x.formatHtml(content?.body.subTitle)}</p>
            </div>
            <b2x.CustomerForm className="mb-4" />
          </b2x.Col>
        </b2x.Row>
      </Container>
    </Page>
  );
};
